import React from 'react';
import { Col, Row, Form, Input } from 'antd';

const { Item } = Form;

const PhoneNumber = () => {
  return (
    <Row span={24}>
      <Col xs={24} md={12}>
        <Row xs={24} md={12}>
          <Col xs={8} md={8}>
            <h4>Phone Number</h4>
          </Col>
          <Col xs={16} md={15}>
            <Item name="phone">
              <Input
                size="large"
                name="phone"
                style={{ borderRadius: 8 }}
                placeholder="Number"
              />
            </Item>
          </Col>
        </Row>
      </Col>
      <Col xs={24} md={12}>
        <Row justify="space-between">
          <Col xs={8} md={8}>
            <h4>Phone Number 2</h4>
          </Col>
          <Col xs={16} md={15}>
            <Item name="phone2">
              <Input
                size="large"
                name="phone2"
                style={{ borderRadius: 8 }}
                placeholder="Number"
              />
            </Item>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default PhoneNumber;
